// `useStats` — TanStack Query hook for /api/stats.
//
// Stats are independent of filter state, so the query key is constant. The
// 30s staleTime matches /api/rankings — both update on the same cadence
// (user-driven submit + admin recompute). Refetch-on-mount is automatic
// once data is stale; refetch-on-window-focus is disabled globally.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { StatsDTO } from '@/types/db';
import { fetchStats } from '@/lib/api';

export function useStats(): UseQueryResult<StatsDTO, Error> {
  return useQuery<StatsDTO, Error>({
    queryKey: ['stats'],
    queryFn: ({ signal }) => fetchStats(signal),
    staleTime: 30_000,
  });
}
